var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0381 52.0032C40.4185 52.0032 52.0761 40.3626 52.0761 26.0032C52.0761 11.6438 40.4185 0.00323486 26.0381 0.00323486C11.6576 0.00323486 0 11.6438 0 26.0032C0 40.3626 11.6576 52.0032 26.0381 52.0032Z",
    fill: "#6066A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_928_3802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 52
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0381 52C40.4185 52 52.0761 40.3594 52.0761 26C52.0761 11.6406 40.4185 0 26.0381 0C11.6576 0 0 11.6406 0 26C0 40.3594 11.6576 52 26.0381 52Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_928_3802)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4468 31.912C23.4468 30.4797 22.1657 34.181 21.8386 34.7799C20.9416 36.4225 19.5713 38.46 17.934 39.4814C14.1452 41.8461 8.17814 42.9092 5.98928 47.2805C4.80467 49.6454 5.66787 53.6613 8.28625 54.8499C9.47845 55.3907 10.5458 56.2921 11.7316 56.7993C17.4326 59.2389 23.5281 58.8481 29.534 57.8319C32.6673 57.3014 36.1765 56.1941 39.1818 55.1941C48.3443 52.1442 53.0571 45.7155 44.1204 39.0229C39.0314 35.2115 30.8859 42.304 29.3045 32.8297C29.0912 31.5523 28.9598 30.5564 28.9598 29.1601",
    fill: "#E3C4A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4037 39.4393C18.1996 39.4188 20.4838 39.7454 21.013 39.8117C23.0373 40.0641 25.1463 40.3548 27.2067 40.0981C28.7514 39.9056 30.3181 39.6594 31.8522 39.4682C36.9535 38.8313 42.2423 36.0801 46.9925 39.4682C48.5465 40.5762 49.3431 41.596 49.1143 43.6486C48.8629 45.9103 47.5808 47.8853 46.4762 49.7761C41.0636 59.0417 27.4773 60.4961 18.1452 57.9075C15.6243 57.2086 12.8611 56.913 10.5748 55.4453C6.68004 52.9451 4.25029 47.5693 8.28125 43.9921C9.95108 42.5094 12.9502 41.3689 15.0487 40.6707C15.846 40.4049 16.6689 39.9119 17.4572 39.7546C17.6324 39.7193 18.6594 39.4648 18.4037 39.4393Z",
    fill: "#F3AA47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4091 19.1494C33.3487 27.1774 31.8397 32.6812 26.1583 33.3442C20.4768 34.0073 15.0048 29.5021 14.0652 21.4738C13.1255 13.4456 16.9693 6.39995 22.651 5.73688C28.3325 5.07364 31.4693 11.1211 32.4091 19.1494Z",
    fill: "#E3C4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9207 24.3146C20.9021 25.0278 21.0851 25.6852 22.4694 26.2866",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7085 29.7109C23.8407 29.7646 25.2876 29.5263 26.1571 27.8699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3772 14.1994C18.3227 15.1665 17.5599 17.0093 15.9381 18.1896C14.1748 19.4742 14.9199 24.6141 14.1298 24.7736C12.0667 25.1914 11.1588 19.3308 10.8417 17.7908C9.87418 13.0934 11.8988 10.0544 15.2965 7.76356C17.7569 6.10477 19.2843 5.69084 21.4671 5.69084C22.8831 5.69084 24.7258 5.18846 26.1599 4.94C32.6701 5.69084 31.4961 7.66642 33.2835 12.005C34.3755 14.6559 38.5068 15.857 38.2156 19.3871C38.0958 20.8435 36.3871 21.778 36.243 23.178C36.0838 24.7221 37.9442 25.8969 36.243 27.6669C35.4953 28.4441 32.6583 29.0595 32.3791 27.3674C31.8949 24.4282 34.1662 21.9398 31.639 19.4866C29.5674 17.4748 26.7369 17.9717 24.5696 16.3939C23.2608 15.4412 24.0753 13.2816 22.3569 13.5962C20.8702 13.8683 21.0808 13.8683 20.3772 14.1994Z",
    fill: "#523C22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7277 22.8201C17.56 21.8731 17.7845 21.0356 18.23 20.949C18.6753 20.8617 19.1726 21.5592 19.3407 22.5062C19.5088 23.4537 19.284 24.2914 18.8382 24.378C18.3932 24.4646 17.8959 23.7676 17.7277 22.8201Z",
    fill: "#000808"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6287 22.8201C24.461 21.8731 24.6855 21.0356 25.131 20.949C25.5763 20.8617 26.0735 21.5592 26.2417 22.5062C26.4098 23.4537 26.1849 24.2914 25.7392 24.378C25.2942 24.4646 24.7969 23.7676 24.6287 22.8201Z",
    fill: "#000808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9125 26.7249C27.9027 26.7551 27.8934 26.7853 27.8835 26.8155",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3538 22.0535C13.9515 22.1173 13.4889 21.093 12.7973 21.8254C11.6925 22.9961 12.8233 27.2368 14.7039 27.0585C15.237 27.0077 15.591 26.4016 15.7007 25.9522C15.938 24.9739 15.821 23.4622 15.0584 22.7016C14.3285 21.9731 13.8791 21.8245 14.2783 22.0553",
    fill: "#E3C4A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4355 20.5928C31.1834 20.7727 31.4539 19.9666 31.5479 19.6718C31.7293 19.0982 32.5861 17.8294 33.3786 18.1773C35.2611 19.0039 34.9333 22.7969 33.2091 23.6257C31.7039 24.3486 32.1856 20.9392 32.4371 20.3912",
    fill: "#E3C4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8024 23.8659C13.494 23.8618 14.4407 24.1599 14.4686 24.1962C14.8004 24.6208 14.409 24.7379 14.31 25.1552",
    stroke: "#000808",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4708 20.5391C31.9228 20.489 34.2165 21.6259 32.5407 22.0202",
    stroke: "#000808",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2518 43.8903C12.8008 44.5793 9.32787 45.8121 8.00342 48.1707",
    stroke: "#000808",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6823 12.9501C15.3622 15.1465 11.7683 15.305 12.4472 18.1927",
    stroke: "#000808",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8835 6.48165C30.2448 6.28415 30.0098 11.0727 31.1258 12.0152",
    stroke: "#000808",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9706 27.167C13.9706 26.6594 14.3829 26.2482 14.8912 26.2482C15.399 26.2482 15.8111 26.6594 15.8111 27.167C15.8111 27.6744 15.399 28.0856 14.8912 28.0856C14.3829 28.0856 13.9706 27.6744 13.9706 27.167Z",
    fill: "#F3AA47"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2422 23.8589C32.2422 23.3701 32.6393 22.9737 33.1286 22.9737C33.6182 22.9737 34.0151 23.3701 34.0151 23.8589C34.0151 24.3477 33.6182 24.744 33.1286 24.744C32.6393 24.744 32.2422 24.3477 32.2422 23.8589Z",
    fill: "#F3AA47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1521 39.7763C18.2727 39.6557 17.8824 39.9892 17.7652 40.1141C17.4222 40.4801 17.1242 40.8476 16.8229 41.2489",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1768 39.8748C20.5879 40.0708 20.2986 41.765 20.2112 42.2156",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2443 40.0209C23.9275 40.6542 23.8944 41.478 23.7618 42.1692",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5808 39.9681C27.717 40.7396 27.6535 41.5027 27.6535 42.2849",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3568 39.5847C31.1454 39.5847 31.3613 41.0621 31.3944 41.6123",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4441 39.0821C34.6295 39.2668 34.9061 39.3782 35.0231 39.6131C35.2213 40.0095 35.2644 40.4659 35.3856 40.8919",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9988 38.1591C37.9785 38.1181 38.5463 38.2359 38.6035 38.2557C39.5083 38.5773 39.3557 38.5575 39.4978 39.4385",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6768 42.94C38.7132 43.0126 40.4337 42.3525 41.1854 40.3981",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.928 20.032C16.2746 19.6941 16.5927 19.4614 17.049 19.3075C17.3064 19.2206 17.6124 19.2628 17.8805 19.2628C18.1377 19.2628 18.3963 19.2994 18.6427 19.2994",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7411 18.8948C24.2613 18.7195 24.7399 18.7117 25.2818 18.7117C25.4579 18.7117 25.7579 18.6538 25.9259 18.7299C26.029 18.7769 26.1618 18.79 26.2723 18.8216C26.3579 18.846 26.6021 19.0421 26.6391 18.9681",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9034 33.126C27.9034 32.7858 27.0405 33.515 24.9821 33.6751C22.9236 33.8353 22.4351 32.9897 22.3016 33.6751C22.168 34.3605 20.8647 36.172 21.0196 36.5511C21.1745 36.9302 27.9034 33.4662 27.9034 33.126Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.818716adfc8fba319fcc3a3dbd16a641.svg";
export { ForwardRef as ReactComponent };